import { RepaymentAdviceActionDispatch, RepaymentAdviceReduxTypes } from "./types";

export const createRepaymentAdvice = (payload: any): RepaymentAdviceActionDispatch => ({
    type: RepaymentAdviceReduxTypes.REPAYMENT_ADVICE_REPORT,
    payload: payload
})